export default __webpack_public_path__ + "static/media/footer-bg-dots.c5840858.png";